module.exports = __webpack_public_path__ + "static/media/clock.1a2dd008.svg";